import { useContext, useEffect, useMemo, useState } from 'react'
import { DesignContext } from 'contexts/DesignContext'
import objectPath from 'object-path'
import { Form, Col, Row, ListGroup, Badge } from 'react-bootstrap'
import { useRouteMatch, useLocation } from 'react-router-dom'
import Label from './Label'
import {
  setListApi,
  setHeadersConfig,
  getApi,
  mapResponseData,
} from '../action/Api'
import { onCheckCondition } from '../action/condition/Action'
import FeatherIcon from 'feather-icons-react'
import httpClient from 'utility/httpClient.util'
import Swal from 'sweetalert2'
import PNotify from 'pnotify/dist/es/PNotify'
import { debounceCallback } from 'utility/debounceCallback.util'
import { useTimeFormat } from 'contexts/TimeFormatContext'
import dayjs from 'dayjs'
import cloneDeep from 'clone-deep'
import { TextField } from '@material-ui/core'
import { Close, Search } from '@mui/icons-material'
import { format12hr, format24hr, isDateValid } from '../action/Date'
import { getDateTimeValue } from '../action/Data'

dayjs.extend(require('dayjs/plugin/customParseFormat'))

const timeParseFormats = [
  ...new Set(
    [...format24hr, ...format12hr]
      .filter(({ maskSign }) => maskSign === ':')
      .map(({ value }) => value),
  ),
]

const CustomList = (props) => {
  let { uischema, config } = props

  const {
    isDynamic = false,
    dynamicName = '',
    dynamicIndex = 0,
    dynamicData = {},
    onUpdateFormData = () => {},
    isArray,
    arrayName,
    isActiveTab = true,
    tabContainerKey,
  } = config

  const fieldKey = isArray
    ? `@${arrayName}.${uischema.key}`
    : isDynamic
    ? `${dynamicName}.${dynamicIndex}.${uischema.key}`
    : uischema.key
  const fieldName = isArray
    ? `@${arrayName}.${uischema.name}`
    : isDynamic
    ? `${dynamicName}.${dynamicIndex}.${uischema.name}`
    : uischema.name

  let {
    key,
    elementWidth,
    controlId,
    maxWidth = '100%',
    maxHeight = '640px',
    listColor,
    listTextColor,
    titleRef = 'title',
    titleValue,
    isShowLatest,
    readonly,
  } = uischema

  const match = useRouteMatch()
  const location = useLocation()
  const search = location.search || []
  const pathParams = match.params
  const urlSearchParams = new URLSearchParams(search)
  const queryParams = Object.fromEntries([...urlSearchParams])
  const urlParams = { ...pathParams, ...queryParams }
  const { formatDate, formatTime, formatDateTime, timeFormat } =
    useTimeFormat()

  const designContext = useContext(DesignContext)
  const {
    jsonForm,
    designerProps,
    elementAction = {},
    getCurrentUi,
    setElementAction,
    setFormData,
    isUiChanged,
    setIsUiChanged,
    setFieldFormData,
    searchData,
    tabParamActive,
    updateUiSchema,
  } = designContext
  const uiChanged = objectPath(isUiChanged)
  const formData = jsonForm.formData
  const isClearActive = uiChanged.get(`${key}.isClearActive`)
  const { actionUpdate = [], updateOption = [] } = elementAction
  const datasourceValue = objectPath.get(designContext, `@datasource`) || {}
  const joinSearch = Object.values(searchData).join('')
  const activeTabParam = tabContainerKey
    ? objectPath.get(tabParamActive, tabContainerKey)
    : tabParamActive
  const activeTabParamString = JSON.stringify(activeTabParam)
  const isLocked = objectPath.get(elementAction, ['isLockedEdit'])
  let hasEnable = objectPath.has(elementAction, ['isEnable', key])
  let isEnable = objectPath.get(elementAction, ['isEnable', key])
  const [filterValue, setFilterValue] = useState('')

  const uiKey = useMemo(() => {
    if (isDynamic) {
      if (designerProps) {
        let elementName = designerProps.filter(
          ({ propType }) => propType === 'name',
        )
        let uiName = elementName.find(
          ({ prop }) => `@${prop}` === uischema.name,
        )
        if (uiName) {
          setLabel(uiName.systemValue)
          return uiName.systemName
        }
      }
      return uischema.name
    }
    return uischema.key
  }, [isDynamic])

  const uiName = useMemo(() => {
    if (isDynamic) {
      if (designerProps) {
        let elementName = designerProps.filter(
          ({ propType }) => propType === 'name',
        )
        let uiName = elementName.find(
          ({ prop }) => `@${prop}` === uischema.name,
        )
        if (uiName) {
          setLabel(uiName.systemValue)
          return uiName.systemName
        }
      }
    }
    if (isArray) {
      return `@${arrayName}.${uischema.name}`
    }
    return uischema.name
  }, [isDynamic])

  let currentSearch = useMemo(() => {
    let fieldSearch = objectPath.get(jsonForm, 'search.field') || []
    let found = fieldSearch.find(({ key }) => key === uiKey)
    return found ? true : false
  }, [uiKey])

  const data = isDynamic ? dynamicData : currentSearch ? searchData : formData
  let list = objectPath.get(data, uiKey) ?? objectPath.get(data, uiName) ?? []
  const deleteAction = objectPath.get(uischema, 'delete') || {}
  const { apiType = '' } = deleteAction
  const action = objectPath.get(deleteAction, `${apiType}Api`)
  const notification = objectPath.get(uischema, `notification`)
  let loadData = objectPath.get(uischema, 'loadData') || {}
  let { isShowFilterList, columnRefId } = loadData
  let isLoadDataGET = objectPath.get(loadData, 'method') === 'GET'
  let isLoadDataSEARCH = objectPath.get(loadData, 'method') === 'SEARCH'
  let isLoadDataJSON = objectPath.get(loadData, 'method') === 'JSON'
  let isActiveLatest = objectPath.get(uischema, 'isActiveLatest')
  let loadItem = objectPath.get(uischema, 'loadItem') || {}
  let isLoadItemGET = objectPath.get(loadItem, 'method') === 'GET'
  let isLoadItemJSON = objectPath.get(loadItem, 'method') === 'JSON'
  let loadJSONItem = objectPath.get(loadItem, 'json') || {}
  let idRef = columnRefId || uischema.idRef
  let {
    optionKey,
    optionRefId,
    isShowAllCheckbox,
    isShowFilterItem,
    filterItemField,
  } = loadJSONItem
  let optionUi = getCurrentUi(optionKey, jsonForm.schema, jsonForm.uischema)
  let selectedDynamicData = objectPath.get(formData, optionUi.name) || []

  const formatTimeTitleItem = (titleItem, format) => {
    let displayFormat = format === undefined ? timeFormat : format
    let timeValue = dayjs(titleItem, timeParseFormats, true)
    if (timeValue.isValid()) return timeValue.format(displayFormat)
    return formatTime(titleItem, format)
  }

  const formatTitleItem = (titleItem, titleConfig = {}) => {
    if (titleConfig.type === 'dateTime') {
      let { dateTimeType, format, custom = {} } = titleConfig
      if (dateTimeType === 'time') {
        let displayFormat = format === 'custom' ? custom.timeFormat : timeFormat
        return formatTimeTitleItem(titleItem, displayFormat)
      }

      return getDateTimeValue(titleItem, titleConfig, {
        formatDate,
        formatTime,
        formatDateTime,
      })
    }

    let isDate = isDateValid(titleItem)
    let dateTitle = formatDate(dayjs(titleItem))
    return isDate ? dateTitle : titleItem
  }

  const indexUpdateList = updateOption.findIndex((item) => item === key)

  const filterKeyOptions = useMemo(() => {
    if (!filterValue) return list
    let options = cloneDeep(list)
    options.map((option, index) => {
      const regex = new RegExp(filterValue, 'ig')
      let labelArray = []
      titleValue.map((titleConfig = {}) => {
        let { title = [] } = titleConfig
        title.map(({ label, value }) => {
          let hasItem = objectPath.has(option, value)
          if (hasItem) {
            let titleItem = objectPath.get(option, value)
            labelArray.push(formatTitleItem(titleItem, titleConfig))
          } else {
            labelArray.push(label)
          }
        })
      })
      let label = labelArray.join(' ')
      if (isShowFilterList) {
        if (regex.test(label)) {
          objectPath.set(option, '@title', label)
          objectPath.set(option, '@index', index)
        }
      }
      if (isShowFilterItem) {
        let filterItemFieldSplit = filterItemField.replace(' ', '').split(',')
        filterItemFieldSplit.forEach((field) => {
          let fieldList = field.split('.#.')
          let subOption
          let lastIndex = fieldList.length - 1
          fieldList.forEach((subField, subIndex) => {
            if (Array.isArray(subOption)) {
              let found = subOption.find((array) => {
                let label = objectPath.get(array, subField)
                return regex.test(label)
              })
              if (subIndex === lastIndex) {
                if (found) {
                  let subTitle = objectPath.get(found, subField)
                  objectPath.set(option, '@title', label)
                  objectPath.set(option, '@subTitle', subTitle)
                  objectPath.set(option, '@index', index)
                }
              }
            } else {
              subOption = objectPath.get(option, subField)
              if (regex.test(subOption) && subIndex === lastIndex) {
                objectPath.set(option, '@title', label)
                objectPath.set(option, '@subTitle', subOption)
                objectPath.set(option, '@index', index)
              }
            }
          })
        })
      }
      return option
    })
    let filter = options.filter((option) => {
      return objectPath.get(option, '@title')
    })
    return filter
  }, [filterValue, JSON.stringify(list)])

  let isReadOnly = useMemo(() => {
    if (isLocked) return isLocked
    if (hasEnable) {
      return isEnable === false ? true : false
    }
    return uischema.readonly
  }, [isEnable, uischema.readonly])

  const [listId, setListId] = useState(null)
  const [active, setActive] = useState(null)
  const [label, setLabel] = useState(null)
  const [hoverIndex, setHoverIndex] = useState(null)

  const updateMapFormData = (form, source) => {
    let jsonKey = objectPath.get(form, 'jsonKey') || ''
    let mapParam = objectPath.get(form, 'mapParam') || {}
    let paramList = Object.keys(mapParam)
    paramList.forEach((paramKey) => {
      let paramName = mapParam[paramKey]
      let dataKey = jsonKey ? `${jsonKey}.${paramName}` : paramName
      let value =
        objectPath.get(source, paramKey) || objectPath.get(source, dataKey)
      setFieldFormData(paramKey, value)
      setFieldFormData(dataKey, value)
      objectPath.set(isUiChanged, paramKey, { isRender: true })
    })
  }

  const viewItem = (item) => {
    new Promise((resolve) => {
      if (isLoadItemJSON) {
        let { action } = loadJSONItem
        if (action === 'OPTION') {
          let { optionKey, optionLabel, optionValue, optionRefId } =
            loadJSONItem
          let optionData = objectPath.get(item, optionRefId)
          let options = []
          if (optionUi.tagname === 'checkboxGroup') {
            optionData.forEach((subItem) => {
              options.push({
                [`@listKey`]: objectPath.get(item, idRef),
                key: objectPath.get(subItem, optionLabel),
                name: objectPath.get(subItem, optionLabel),
                label: objectPath.get(subItem, optionLabel),
                value: objectPath.get(subItem, optionValue),
                formData: true,
                valueChecked: true,
                defaultChecked: false,
                valueUnchecked: false,
              })
            })
            let labelArray = []
            titleValue.map((titleConfig = {}) => {
              let { title = [] } = titleConfig
              title.map(({ label, value }) => {
                let hasItem = objectPath.has(item, value)
                if (hasItem) {
                  let titleItem = objectPath.get(item, value)
                  labelArray.push(formatTitleItem(titleItem, titleConfig))
                } else {
                  labelArray.push(label)
                }
              })
            })
            updateUiSchema(optionKey, 'label', labelArray.join(' '))
            updateUiSchema(optionKey, 'options', options)
          } else if (optionUi.tagname === 'select') {
            optionData.forEach((subItem) => {
              options.push({
                ...subItem,
                [`@listKey`]: objectPath.get(item, idRef),
                label: objectPath.get(subItem, optionLabel),
                value: objectPath.get(subItem, optionValue),
              })
            })
            updateUiSchema(optionKey, 'optionType', 'custom')
            updateUiSchema(optionKey, 'custom.options', options)
          }

          updateUiSchema(optionKey, 'connectList', uischema.key)
          objectPath.set(isUiChanged, optionKey, { isRender: true })
          setIsUiChanged(isUiChanged)
        } else if (action === 'CONTAINER') {
          let containerKey = objectPath.get(loadItem, 'json.optionKey')
          let uiItem = getCurrentUi(containerKey)
          let refId = objectPath.get(loadItem, 'json.optionRefId')
          let viewIndex = list.findIndex(
            (itemList) =>
              objectPath.get(itemList, refId) === objectPath.get(item, refId),
          )
          objectPath.set(isUiChanged, ['viewListItem', containerKey], {
            refId,
            uiItem,
            item,
            viewKey: `${uischema.name}.${viewIndex}`,
            containerKey,
          })
        } else {
          let formGroupKey =
            loadJSONItem?.formGroupKey || loadItem?.formGroupKey
          let form = jsonForm.formGroup.find(({ key }) => key === formGroupKey)
          if (form) {
            if (form.isGroup) {
              let groupData = form.groupData || []
              groupData.forEach((subGroup) => {
                updateMapFormData(subGroup, item)
              })
            } else {
              updateMapFormData(form, item)
            }
          }
        }
      }
      resolve()
    }).then(() => {
      setIsUiChanged(isUiChanged)
      onCheckCondition(designContext, formData, key, {
        isActive: true,
        listItem: item,
      })
    })
  }

  const cancelItem = () => {
    onCheckCondition(designContext, formData, key, {
      isActive: false,
    })

    setActive(null)
  }

  const deleteItem = async (item) => {
    let url = setListApi(
      { ...deleteAction, idRef },
      {
        listValue: item,
        formData,
      },
    )
    let config = setHeadersConfig(action)
    let response = await httpClient
      .delete(url, config)
      .then(({ data }) => {
        return { status: 200, data: data, message: 'success' }
      })
      .catch(function (error) {
        if (error.response) {
          return {
            status: error.response.status,
            message: error.response.data,
            data: null,
          }
        }
      })
    showNotification(response)
  }

  const showNotification = async (response) => {
    let { status, message = '', apiName = '' } = response || {}
    if (notification.isNotified) {
      if (status >= 200 && status < 300) {
        let notice = PNotify.success({
          title: notification.notifySuccessTitle || 'Success',
          text: notification.notifySuccessText,
          icon: 'fas fa-check-circle fa-xl',
        })
        notice.on('click', () => {
          notice.close()
        })
        console.log(`Success API Name: ${apiName}`)
        renderList()
      } else {
        let notice = PNotify.error({
          title: notification.notifyErrorTitle || 'Error',
          text:
            JSON.stringify(message, null, 2) || notification.notifyErrorText,
          icon: 'fas fa-exclamation-circle fa-xl',
        })
        notice.on('click', () => {
          notice.close()
        })
        console.error(`Error API Name: ${apiName}`)
      }
    }
  }

  const onBeforeAlert = (beforeAction, listItem) => {
    if (beforeAction.name === 'alert') {
      onAlert(beforeAction, true, listItem)
    }
  }

  const renderList = () => {
    if (isLoadDataJSON) {
    } else if (isLoadDataSEARCH) {
      debounceCallback(
        loadListByGet,
        [jsonForm.search, { formData, urlParams, designContext }, updateUi],
        'searchList',
      )
    } else {
      let loadData = objectPath.get(uischema, 'loadData.get')
      debounceCallback(
        loadListByGet,
        [loadData, { formData, urlParams, designContext }, updateUi],
        'getList',
      )
    }
  }

  const renderItem = (item) => {
    if (isLoadItemGET) {
      let loadItem = objectPath.get(uischema, 'loadItem.get')
      debounceCallback(
        loadItemByGet,
        [
          { ...loadItem, idRef },
          { formData, urlParams, designContext, listValue: item },
        ],
        'getItem',
      )
    } else {
      viewItem(item)
    }
  }

  const loadListByGet = async (searchApi, searchData, updateUi) => {
    let { formData } = searchData
    if (!searchApi) return formData
    let data = null
    let api = getApi(searchApi, searchData)
    if (!api) return formData
    let config = setHeadersConfig(searchApi)
    let response = await httpClient
      .get(api, config)
      .then(({ data }) => data)
      .catch(() => [])

    // has data key
    if (searchApi.data) {
      data = objectPath.get(response, searchApi.data)
    } else {
      data = response
    }
    setFieldFormData(uischema.name, data)
    setFieldFormData(uischema.key, data)
    if (updateUi) {
      updateUi()
    }
    return formData
  }

  const loadItemByGet = async (searchApi, searchData, updateUi) => {
    let { formData } = searchData
    if (!searchApi) return formData
    let data = null
    let api = getApi(searchApi, searchData)
    if (!api) return formData
    let config = setHeadersConfig(searchApi)

    let response = await httpClient
      .get(api, config)
      .then(({ data }) => data)
      .catch(() => [])

    // has data key
    if (searchApi.data) {
      data = objectPath.get(response, searchApi.data)
    } else {
      data = response
    }
    if (searchApi.dataTable) {
      searchApi.dataTable.forEach((table) => {
        let key = table.key
        formData = mapResponseData(
          searchApi,
          cloneDeep(data),
          formData,
          {},
          jsonForm,
        )
        if (key) {
          uiChanged.set(key, { isRender: true })
        }
      })
      setIsUiChanged(uiChanged.get(''))
    }
    setFormData(formData)
    if (updateUi) {
      updateUi()
    }
    return formData
  }

  const onAlert = (action, isBeforeAction, listItem) => {
    let alert = objectPath.get(action, 'alert') || {}
    Swal.fire({
      title: alert.title,
      text: alert.text,
      icon: alert.icon,
      confirmButtonText: alert.confirmButtonText,
      confirmButtonColor: alert.confirmButtonColor,
      showCancelButton: alert.showCancelButton,
      cancelButtonText: alert.cancelButtonText,
      cancelButtonColor: alert.cancelButtonColor,
      showCloseButton: alert.showCloseButton,
      showDenyButton: alert.showDenyButton,
      denyButtonText: alert.denyButtonText,
      denyButtonColor: alert.denyButtonColor,
      reverseButtons: alert.reverseButtons,
    }).then((result) => {
      if (result.isConfirmed) {
        if (alert.confirmAlert) {
          Swal.fire(alert.confirmTitle, alert.confirmText, 'success')
        }
        if (isBeforeAction) {
          deleteItem(listItem)
        }
      } else if (result.isDenied) {
        if (alert.denyAlert) {
          Swal.fire(alert.denyTitle, alert.denyText, 'info')
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        if (alert.cancelAlert) {
          Swal.fire(alert.cancelTitle, alert.cancelText, 'error')
        }
      }
    })
  }

  const updateUi = () => {
    uiChanged.set(uischema.key, { isRender: true })
    setIsUiChanged(uiChanged.get(''))
    if (isActiveLatest) {
      let activeIndex = 0
      let itemUpdate = list[activeIndex]
      let listId = objectPath.get(itemUpdate, idRef)
      setListId(listId)
      setActive(activeIndex)
    }
  }

  const [isCheckedAll, setIsCheckedAll] = useState(false)
  const isRender = objectPath.get(isUiChanged, [optionUi.key, 'isRender'])
  const isSelectedList = objectPath.get(isUiChanged, [
    uischema.key,
    'isSelectedList',
  ])
  const isUnSelectedList = objectPath.get(isUiChanged, [
    uischema.key,
    'isUnSelectedList',
  ])

  useEffect(() => {
    let isCheckedAll = getCheckAll()
    setIsCheckedAll(isCheckedAll)
  }, [isRender])

  useEffect(() => {
    if (isSelectedList) {
      list.map((item, index) => {
        const selectedItem = objectPath.get(isUiChanged, [
          uischema.key,
          'selectedItem',
        ])
        if (index === selectedItem.index) return
        updateDynamicValue(item, index, false)
      })
      const { item, index, checked } = objectPath.get(isUiChanged, [
        uischema.key,
        'selectedItem',
      ])
      updateDynamicValue(item, index, checked)
      objectPath.set(isUiChanged, uischema.key, {})
      setIsUiChanged(isUiChanged)
    }
  }, [isSelectedList])

  useEffect(() => {
    if (isUnSelectedList) {
      list.map((item, index) => {
        updateDynamicValue(item, index, false)
      })
      objectPath.set(isUiChanged, uischema.key, {})
      setIsUiChanged(isUiChanged)
    }
  }, [isUnSelectedList])

  const getCheckAll = () => {
    if (optionUi.key === uischema.key) {
      let dynamicData = isDynamic ? list : selectedDynamicData
      if (dynamicData.length === 0) return false
      let checkDynamic = dynamicData.filter((item) =>
        objectPath.get(item, '@isChecked'),
      )
      return checkDynamic.length === dynamicData.length
    }
  }

  const updateAllDynamicValue = () => {
    if (optionUi.key === uischema.key) {
      let dynamicData = isDynamic ? list : selectedDynamicData
      let checkDynamic = dynamicData.filter((item) =>
        objectPath.get(item, '@isChecked'),
      )
      let isCheckedAll = checkDynamic.length === dynamicData.length
      let isUpdateChecked = !isCheckedAll
      setIsCheckedAll(isUpdateChecked)
      dynamicData.map((item, index) => {
        updateDynamicValue(item, index, isUpdateChecked)
      })
    }
  }

  const updateDynamicValue = (item, index, checked) => {
    let optionData = objectPath.get(item, optionRefId)
    if (optionUi.key === uischema.key) {
      if (isDynamic) {
        objectPath.set(dynamicData, `${optionUi.name}.${index}`, item)
        objectPath.set(formData, `${dynamicName}.${dynamicIndex}`, dynamicData)
      } else {
        objectPath.set(formData, `${uischema.key}.${index}`, item)
        objectPath.set(formData, `${uischema.name}.${index}`, item)
      }
    } else {
      let dynamicIndex = selectedDynamicData.findIndex((item) => {
        let itemId = objectPath.get(item, optionRefId)
        return itemId === optionData
      })
      if (checked) {
        if (dynamicIndex === -1) {
          selectedDynamicData.push(item)
        }
      } else {
        objectPath.del(selectedDynamicData, dynamicIndex)
      }
      objectPath.set(formData, optionUi.name, selectedDynamicData)
      objectPath.set(formData, optionUi.key, selectedDynamicData)
      objectPath.set(isUiChanged, optionUi.key, { isRender: true })
    }
    setIsUiChanged(isUiChanged)
    objectPath.set(list, [index, '@isChecked'], checked)
    objectPath.set(formData, uischema.key, list)
    setFormData(formData)
  }

  const updateOptionValue = (item, index, checked) => {
    let { optionLabel } = loadJSONItem
    let optionData = objectPath.get(item, optionRefId)
    if (optionUi.tagname === 'checkboxGroup') {
      let joinValue = optionUi.joinValue
      let valueText = objectPath.get(formData, optionUi.key) || ''
      let valueList = valueText.split(joinValue)
      optionData.forEach((subItem) => {
        let name = objectPath.get(subItem, optionLabel)
        objectPath.set(formData, name, checked)
        if (checked) {
          valueList.push(name)
        } else {
          let index = valueList.findIndex((value) => value === name)
          if (index > -1) {
            valueList.splice(index, 1)
          }
        }
      })
      valueList = valueList.filter((value) => value)
      if (optionUi.valueType === 'text') {
        valueText = valueList.join(joinValue)
        objectPath.set(formData, optionUi.key, valueText)
        objectPath.set(formData, optionUi.name, valueText)
      }
    }
    objectPath.set(isUiChanged, optionUi.key, { isRender: true })
    setIsUiChanged(isUiChanged)
    objectPath.set(list, [index, '@isChecked'], checked)
    objectPath.set(formData, uischema.key, list)
    setFormData(formData)
  }

  useEffect(() => {
    onCheckCondition(designContext, formData, key)
    objectPath.set(elementAction, 'actionUpdate', [])
    setElementAction(elementAction)
  }, [])

  useEffect(() => {
    if (!isActiveTab || !isActiveLatest) {
      cancelItem()
    }
  }, [activeTabParamString, isActiveTab])

  useEffect(() => {
    if (isActiveTab) {
      renderList()
    }
  }, [joinSearch, activeTabParamString, isActiveTab])

  useEffect(() => {
    if (indexUpdateList > -1) {
      objectPath.del(updateOption, indexUpdateList)
      setActive(null)
      objectPath.set(elementAction, 'updateOption', updateOption)
      setElementAction(elementAction)
    }
  }, [indexUpdateList])

  useEffect(() => {
    if (isActiveLatest) {
      let activeIndex = 0
      let itemUpdate = list[activeIndex]
      let listId = objectPath.get(itemUpdate, idRef)
      setListId(listId)
      setActive(activeIndex)
      renderItem(itemUpdate)
    } else {
      let recheckIndex = list.findIndex(
        (item) => objectPath.get(item, idRef) === listId,
      )
      if (recheckIndex > -1) {
        let itemUpdate = list[recheckIndex]
        setListId(listId)
        setActive(recheckIndex)
        renderItem(itemUpdate)
      }
    }
  }, [JSON.stringify(list)])

  useEffect(() => {
    if (isClearActive) {
      uiChanged.set(key, { isClearActive: false })
      setActive(null)
      setListId(null)
      setIsUiChanged(isUiChanged)
    }
  }, [isClearActive])

  if (loadJSONItem.action === 'DYNAMIC') {
    return (
      <Form.Group className="mb-0" controlId={controlId}>
        <Row className="w-100 mx-0">
          {(isShowFilterList || isShowFilterItem) && (
            <>
              <Col sm="12" className="px-0 mb-3">
                <TextField
                  placeholder="ค้นหา"
                  InputProps={{
                    startAdornment: <Search className="text-secondary" />,
                  }}
                  onChange={(e) => {
                    let widget = e.target.value
                    setFilterValue(widget)
                  }}
                  value={filterValue}
                />
                {filterValue && (
                  <FeatherIcon
                    icon="x"
                    size="18"
                    className="text-secondary"
                    onClick={() => setFilterValue('')}
                    style={{
                      position: 'relative',
                      left: '-20px',
                      top: '2px',
                      cursor: 'pointer',
                    }}
                  />
                )}
              </Col>
            </>
          )}
          <Label {...props} uischema={uischema} label={label} />
          <Col sm={elementWidth} className="mt-1 p-0">
            <ListGroup
              id={`list-group-${fieldKey}`}
              style={{
                overflowY: 'auto',
                maxWidth: maxWidth,
                maxHeight: maxHeight,
              }}
            >
              {list?.length > 0 && (
                <>
                  {isShowAllCheckbox && (
                    <ListGroup.Item
                      id={`list-check-all`}
                      className={`px-0 py-2 d-flex`}
                      onClick={(e) => {
                        if (!isReadOnly) {
                          updateAllDynamicValue()
                        }
                      }}
                    >
                      <span className={`d-flex w-100 align-items-center`}>
                        <Form.Check
                          id={`list-check-all`}
                          style={{
                            display: 'grid',
                            width: '24px',
                            height: '24px',
                          }}
                          className="ml-2 mr-0 mr-2"
                          name="isChecked"
                          checked={isCheckedAll}
                          disabled={isReadOnly}
                        />
                        <Row
                          id={`list-check-all`}
                          className="btn mx-0 w-100 p-0"
                          style={{ textAlign: 'left' }}
                        >
                          ทั้งหมด
                        </Row>
                      </span>
                    </ListGroup.Item>
                  )}
                  {filterKeyOptions.map((item, index) => {
                    let checked = objectPath.get(item, '@isChecked')
                    if (objectPath.has(item, '@index')) {
                      index = objectPath.get(item, '@index')
                    }
                    return (
                      <ListGroup.Item
                        id={`list-item-${fieldKey}-${index}`}
                        className={`px-0 py-2 d-flex`}
                        onClick={(e) => {
                          if (!isReadOnly) {
                            updateDynamicValue(item, index, !checked)
                          }
                        }}
                      >
                        <span className={`d-flex w-100 align-items-center`}>
                          <Form.Check
                            id={`list-check-${fieldKey}-${index}`}
                            style={{
                              display: 'grid',
                              width: '24px',
                              height: '24px',
                            }}
                            className="ml-2 mr-0"
                            name="isChecked"
                            checked={checked}
                            disabled={isReadOnly}
                          />
                          <Row
                            id={`list-row-${fieldKey}-${index}`}
                            className="btn mx-0 w-100 p-0"
                            style={{ textAlign: 'left' }}
                          >
                            {titleValue.map((titleConfig = {}) => {
                              let { title = [] } = titleConfig
                              return (
                                <Col sm="12" className="row w-100 ml-0 px-0">
                                  {title.map(({ label, value }) => {
                                    let hasItem = objectPath.has(item, value)
                                    if (hasItem) {
                                      let titleItem = objectPath.get(
                                        item,
                                        value,
                                      )
                                      return (
                                        <Col sm="auto" className="px-2">
                                          {formatTitleItem(
                                            titleItem,
                                            titleConfig,
                                          )}{' '}
                                        </Col>
                                      )
                                    } else {
                                      return (
                                        <Col sm="auto" className="px-1">
                                          {label}
                                        </Col>
                                      )
                                    }
                                  })}
                                </Col>
                              )
                            })}
                          </Row>
                        </span>
                      </ListGroup.Item>
                    )
                  })}
                </>
              )}
            </ListGroup>
          </Col>
        </Row>
      </Form.Group>
    )
  }

  return (
    <Form.Group className="mb-0" controlId={controlId}>
      <Row className="w-100 mx-0">
        <Label {...props} uischema={uischema} label={label} />
        <Col sm={elementWidth} className="mt-1 p-0">
          <ListGroup
            id={`list-group-${fieldKey}`}
            style={{
              overflowY: 'auto',
              maxWidth: maxWidth,
              maxHeight: maxHeight,
            }}
          >
            {list?.length > 0 &&
              filterKeyOptions.map((item, index) => {
                if (objectPath.has(item, '@index')) {
                  index = objectPath.get(item, '@index')
                }
                let isActive = index === active ? 'active' : ''

                let title = titleRef
                  ? objectPath.get(item, titleRef)
                  : JSON.stringify(item)
                let isDate = isDateValid(title)
                let dateTitle = formatDate(dayjs(title))

                return (
                  <ListGroup.Item
                    id={`list-item-${fieldKey}-${index}`}
                    className={`px-0 py-2 d-flex`}
                    style={
                      isActive
                        ? { backgroundColor: listColor, color: listTextColor }
                        : {}
                    }
                  >
                    <span className={`d-flex w-100 align-items-center`}>
                      {loadJSONItem.action === 'OPTION' && (
                        <Form.Check
                          id={`list-check-${fieldKey}-${index}`}
                          style={{
                            display: 'grid',
                            width: '24px',
                            height: '24px',
                          }}
                          className="ml-2 mr-0"
                          name="isChecked"
                          checked={objectPath.get(item, '@isChecked')}
                          disabled={isReadOnly}
                          onChange={(e) => {
                            if (!isReadOnly) {
                              updateOptionValue(item, index, e.target.checked)
                            }
                          }}
                        />
                      )}
                      {titleValue ? (
                        <Row
                          id={`list-row-${fieldKey}-${index}`}
                          className="btn mx-0 w-100 p-0"
                          style={{ textAlign: 'left' }}
                          onClick={() => {
                            if (!isReadOnly) {
                              let id = objectPath.get(item, idRef)
                              setListId(id)
                              setActive(index)
                              renderItem(item)
                            }
                          }}
                        >
                          {index === 0 && isShowLatest ? (
                            <Badge variant="danger">ล่าสุด</Badge>
                          ) : (
                            ''
                          )}
                          {titleValue.map((titleConfig = {}) => {
                            let { title = [] } = titleConfig
                            return (
                              <Col sm="12" className="row w-100 ml-0 px-0">
                                {title.map(({ label, value }) => {
                                  let hasItem = objectPath.has(item, value)
                                  if (hasItem) {
                                    let titleItem = objectPath.get(item, value)
                                    return (
                                      <Col
                                        sm="auto"
                                        className="font-weight-bold px-2"
                                      >
                                        {formatTitleItem(
                                          titleItem,
                                          titleConfig,
                                        )}{' '}
                                      </Col>
                                    )
                                  } else {
                                    return (
                                      <Col sm="auto" className="px-1">
                                        {label}
                                      </Col>
                                    )
                                  }
                                })}
                              </Col>
                            )
                          })}
                        </Row>
                      ) : (
                        <Row
                          id={`list-row-${fieldKey}-${index}`}
                          className="mx-0 w-100 btn"
                          style={{ textAlign: 'left' }}
                          onClick={() => {
                            if (!isReadOnly) {
                              let id = objectPath.get(item, idRef)
                              setListId(id)
                              setActive(index)
                              renderItem(item)
                            }
                          }}
                        >
                          <Col sm="12" className="px-0">
                            {index === 0 && isShowLatest ? (
                              <Badge variant="danger">ล่าสุด</Badge>
                            ) : (
                              ''
                            )}
                          </Col>
                          <Col sm="12" className="px-0">
                            {isDate ? dateTitle : title}
                          </Col>
                        </Row>
                      )}
                    </span>
                    {action && (
                      <span
                        id={`list-delete-${fieldKey}-${index}`}
                        className={`btn p-2 d-flex align-items-center ${
                          index === hoverIndex
                            ? 'bg-danger text-white'
                            : 'text-danger'
                        }`}
                        onClick={() => {
                          if (!isReadOnly) {
                            let beforeAction =
                              objectPath.get(uischema, 'beforeAction') || {}
                            if (beforeAction.isEnabled) {
                              onBeforeAlert(beforeAction, item)
                            } else {
                              deleteItem(item)
                            }
                          }
                        }}
                        onMouseEnter={() => setHoverIndex(index)}
                        onMouseLeave={() => setHoverIndex(null)}
                      >
                        <FeatherIcon size="16" icon="trash" />
                      </span>
                    )}
                  </ListGroup.Item>
                )
              })}
          </ListGroup>
        </Col>
      </Row>
    </Form.Group>
  )
}

export default CustomList
